// Working Drill Table 2
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { removeCommas } from "../../../../../appFunctions";
import UpArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/UpArrownIcon/elements.svg";
import DownArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/DownArrowIcon/elements.svg";
import { Tooltip } from "@mui/joy";

type RowProps = {
  headerName: string;
  field: string;
};
type SelectedArr = {
  type: string;
  name: string;
};
type All_Sel_CategoriesProps = {
  principal_category: string[];
  main_category: string[];
  category: string[];
  sub_category: string[];
  product_name: string[];
  style_code: string[];
  model_code: string[];
  variant_code: string[];
  sku: string[];
  platform_code: string[];
  campaign_id: string[]; // campaign_id
  campaign_name: string[];
  adgroup_id: string[],
  adgroup_name: string[];
  match_type: string[];
  searchterm: string[];
  [key: string]: string[]; // Allows dynamic indexing
};
type SortProps = {
  metric: string;
  sort_by: string;
  direction: string;
};
type SearchObjProps = {
  value: string;
  frontend_value_type: string;
  backend_value_type: string;
};
type ColumnsHierarchyObj = {
  backend_name: string;
  frontend_name: string;
}
type Condition = {
  metric: string;
  parameter: string;
  // operator?: string;
  initial_value: string;
  dependent_value: string;
  Operation: string;
};
type IconTooltipProps = {
  name: string;
};
type DrillThroughTableProps = {
  data : any[];
  cols_hierarchy: ColumnsHierarchyObj[];
  columns: RowProps[];
  selectedarr: SelectedArr[];
  setSelectedArr: Dispatch<SetStateAction<SelectedArr[]>>;
  sel_categories: All_Sel_CategoriesProps;
  setSel_Categories: Dispatch<SetStateAction<All_Sel_CategoriesProps>>;
  selPreviousArr: SelectedArr[];
  fetchonClick: (data: any, sel_categories: All_Sel_CategoriesProps, selectedcatarr: SelectedArr[], sort: SortProps) => void;
  positive_values: string[];
  negative_values: string[];
  parameters_hierarchy: string[];
  sort: SortProps;
  setSort: Dispatch<SetStateAction<SortProps>>;
  searchobj: SearchObjProps;
  setSearchObj: Dispatch<SetStateAction<SearchObjProps>>;
  setSearchBackendObj: Dispatch<SetStateAction<SearchObjProps>>;
  onChangeSearchObjArr: (col_name: string) => void;
  onChangeSearchObjArr2: (arr: any[]) => void;
  sel_parameters: string[];
  conditionsArr: Condition[];
}
const DrillThroughTable: React.FC<DrillThroughTableProps> = ({data, cols_hierarchy, columns, selectedarr, setSelectedArr, sel_categories, setSel_Categories, selPreviousArr, fetchonClick, positive_values, negative_values, parameters_hierarchy, sort, setSort, searchobj, setSearchObj, setSearchBackendObj, onChangeSearchObjArr, onChangeSearchObjArr2, sel_parameters, conditionsArr}) => {
  const productDetailRowRef = useRef<HTMLDivElement>(null);

  const [rsmatricearr, setRsMatricearr] = useState(["spend", "sales", "gross_sales", "organic_sales"]);

  const [rowHeight, setRowHeight] = useState<number>(50);

  useEffect(() => {
    if (productDetailRowRef.current) {
      productDetailRowRef.current.scrollTo({
        top: sel_parameters?.length > 2 ? (selPreviousArr?.length - 1) * 62 :  (selPreviousArr?.length - 1) * 50,
        behavior: 'smooth'
      });
    }
  }, [data]);

  useEffect(() =>{
    setRowHeight(sel_parameters?.length === 3 ? 62 : sel_parameters?.length === 4 ? 80 : 50);
  }, [sel_parameters]);

  const IconTooltip = ({name } : IconTooltipProps) => {
    return (
        <div
        style={{
            backgroundColor: "#3C3C3F",
            padding: "8px",
            borderRadius: "4px",
        }}
        >
        <div
            style={{
            color: "var(--Text-Primary-White, #FFF)",
            fontFamily: "Inter",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "10px",
            textDecoration: "upperCase",
            letterSpacing: "1.6px",
            }}
        >
            {name}
        </div>
        </div>
    );
    };
  
  const RenderRows = (data: any) => {
    const rows: JSX.Element[] = [];
    let index = 0; // <-- Proper global index across all nodes

    const drilldown = (item: any) => {
      const previousexist = selectedarr?.filter(
        (item2) => item2?.type === item?.type
      );

      if(item?.type !== cols_hierarchy[cols_hierarchy?.length - 1] ){
        if (previousexist?.length === 0) {
          setSelectedArr((prev) => {
            let new_selected_arr;
            if(item?.type === "campaign_id" || item?.type === "adgroup_id"){
              new_selected_arr = [
                ...prev,
                { type: item?.type, name: item?.id }]
            } else{
                new_selected_arr = [
                ...prev,
                { type: item?.type, name: item?.name },
              ];
            }

            let new_sel_categories = {} as All_Sel_CategoriesProps;
            new_selected_arr?.map((item : SelectedArr) =>{
                new_sel_categories[item?.type] = [item?.name]
            });
          setSel_Categories(new_sel_categories);
          if(item?.children?.length === 0){
            setSearchObj((prev) => {
              let obj = cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedarr[selectedarr?.length - 1].type === item?.backend_name) + 2];
              
              return {
                value: "",
                frontend_value_type: obj?.frontend_name,
                backend_value_type: obj?.backend_name
              }
            });
            fetchonClick(item, new_sel_categories, new_selected_arr, {metric: "", sort_by: "", direction: ""});
          }
          else {
            onChangeSearchObjArr2(item?.children);
            setSearchBackendObj({
              value: "",
              frontend_value_type: "",
              backend_value_type: ""
            });
      
            setSearchObj((prev) => ({
              value: "",
              backend_value_type: cols_hierarchy[cols_hierarchy?.findIndex(item2 => item2?.backend_name === item?.type) + 1]?.backend_name,
              frontend_value_type: cols_hierarchy[cols_hierarchy?.findIndex(item2 => item2?.backend_name === item?.type) + 1]?.frontend_name
             }))
          }

          return new_selected_arr;
        });
        } else if (previousexist?.length > 0) {
          setSelectedArr((prev) => {
            const startIndex = cols_hierarchy.findIndex(item2  => item2?.backend_name === item?.type);;
            let new_selected_arr = [] as SelectedArr[];
            if (startIndex !== -1) {
              // Slice the array starting from the input value
              const newHierarchy = cols_hierarchy.slice(startIndex)?.map(item => item?.backend_name);
              let new_arr = prev.filter(
                (item2) => !newHierarchy?.includes(item2?.type)
              );
              if(item?.type === "campaign_id" || item?.type === "adgroup_id"){
                new_selected_arr = [
                  ...prev,
                  { type: item?.type, name: item?.id }]
              } else{
                  new_selected_arr = [
                  ...prev,
                  { type: item?.type, name: item?.name },
                ];
              }
            }

            let new_sel_categories = {} as All_Sel_CategoriesProps;
            new_selected_arr?.map((item : SelectedArr) =>{
              new_sel_categories[item?.type] = [item?.name]
            });
            // if(item?.children?.length === 0){
            setSel_Categories(new_sel_categories);
            if(item?.children?.length === 0){
              setSearchObj((prev) => {
                let obj = cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedarr[selectedarr?.length - 1].type === item?.backend_name) + 2];
                
                return {
                  value: "",
                  frontend_value_type: obj?.frontend_name,
                  backend_value_type: obj?.backend_name
                }
              });
              fetchonClick(item, new_sel_categories, new_selected_arr, {metric: "", sort_by: "", direction: ""});
            }
            else{
              onChangeSearchObjArr2(item?.children);
            }

            return new_selected_arr;
          });
        }
        
        setSearchBackendObj({
          value: "",
          frontend_value_type: "",
          backend_value_type: ""
        });
      }

      setSort((prev) =>( {
        ...prev,
        metric: "",
        direction: ""
      }));
     
    };

    const drillUp = (item: any) => {
      onChangeSearchObjArr(selectedarr[selectedarr?.length - 1]?.type);
      setSelectedArr((prev) => {
        const startIndex = cols_hierarchy.findIndex(item2  => item2?.backend_name === item?.type);
        let new_selected_arr = [] as SelectedArr[];
        if (startIndex !== -1) {
          const newHierarchy = cols_hierarchy?.slice(startIndex)?.map(item => item?.backend_name);
          new_selected_arr = prev.filter(
            (item2) => !newHierarchy?.includes(item2?.type)
          );
        }
        let new_sel_categories = {} as All_Sel_CategoriesProps;
          new_selected_arr?.map((item : SelectedArr) =>{
            new_sel_categories[item?.type] = [item?.name]
          });
        setSel_Categories((prev) => {
          return new_sel_categories;
        });

        // if(conditionsArr?.length > 0){
        //   fetchonClick(item, new_sel_categories, new_selected_arr, {metric: "", sort_by: "", direction: ""});
        // }
        // setOnClickToggle(false);
        console.log('->', new_selected_arr);
        setSearchObj((prev) => ({
          value: "",
          backend_value_type: new_selected_arr[new_selected_arr?.length - 1]?.type,
          frontend_value_type: cols_hierarchy[cols_hierarchy?.findIndex((item : ColumnsHierarchyObj) => item?.backend_name === new_selected_arr[new_selected_arr?.length - 1]?.type) + 1]?.frontend_name ?? ""
         }))
        return new_selected_arr;
      });

      setSort((prev) =>( {
        ...prev,
        metric: "",
        direction: ""
      }));

      setSearchBackendObj({
        value: "",
        frontend_value_type: "",
        backend_value_type: ""
      });


    };

    const traverseData = (node: any, level: number) => {
      // Push the current node's Row
      if(selectedarr?.some(item => item?.type === node?.type)){
        if(selectedarr?.some(item => item?.type === node?.type && item?.name == node?.name)){
          rows.push(
            <div key={`${node?.type}-${node?.name}`} className="relative h-fit">
              <div
                style={{
                  display: "flex",
                  width: "fit-content",
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 5,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "sticky",
                    left: 0,
                    top: 0,
                    // width: `${(selectedarr?.length * 24) + 250}px`,
                    // paddingLeft: level*24,
                    width: 300,
                    paddingRight: "12px",
                    paddingLeft: "12px",
                    height: rowHeight,
                    backgroundColor: selectedarr[selectedarr?.length - 1]?.type === node?.type ? "#E3EDF8" : selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? "#FAFAFA" :
                    selectedarr?.filter(
                      (item) =>
                        item?.name === node?.name && item?.type === node?.type
                    )?.length > 0
                      ? "#FAFAFA"
                      : "#FFF",
                      borderBottom: "1px solid #EAEAED",
                      borderRight: "1px solid #EAEAED",
                    //   boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
                  }}
                >
                  <div
                    className="flex w-full py-1 flex-col justify-between items-start gap-1 self-stretch"
                    style={{   
                      height: rowHeight                  
                    }}
                  >
                    <div
                      style={{
                        color: "var(--Text-Primary-Grey, #97979A)",
                        fontFamily: "Inter",
                        fontSize: "8px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "8px",
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {cols_hierarchy?.find(item => item?.backend_name === node?.type)?.frontend_name}
                    </div>
                    <div className="flex items-center gap-1">
                      <div
                        style={{
                          color: "var(--Text-Primary-Black, #1C1C1E)",
                          fontFamily: "Inter",
                          fontSize: "11px",
                          fontStyle: "normal",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          maxWidth: "246px",
                          textWrap: "wrap",
                          fontWeight:
                            selectedarr?.filter(
                              (item) =>
                                item?.type === node?.type &&
                                item?.name === node?.name
                            )?.length > 0
                              ? 700
                              : 400,
                          lineHeight:
                            selectedarr?.filter(
                              (item) =>
                                item?.type === node?.type &&
                                item?.name === node?.name
                            )?.length > 0
                              ? "14px"
                              : "16px",
                        }}
                      >
                        {node?.name}
                      </div>

                      {cols_hierarchy[cols_hierarchy?.length - 1]?.backend_name !== node?.type && (
                        <div
                        className="flex p-1 items-center gap-1 rounded-[4px]"
                        style={{
                          backgroundColor:
                            node?.type !== "product_code" ? "#F3F3F7" : "#FFF",
                          cursor: selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? "default" : "pointer"
                        }}
                        onClick={() => {
                          if(selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type)){
                            return;
                          }
                          else {
                            if (
                              selectedarr?.filter(
                                (item) =>
                                  item?.type === node?.type &&
                                  item?.name === node?.name
                              )?.length > 0
                            ) {
                              drillUp(node);
                            } else {
                              drilldown(node);
                            }
                          }
                        }}
                      >
                        {node.type !== "product_code" &&
                          (selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type)  ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M9.41287 1.25C9.78429 1.25 10.1 1.38042 10.36 1.64125C10.62 1.90208 10.75 2.21879 10.75 2.59137C10.75 2.89396 10.6587 3.164 10.476 3.4015C10.2933 3.639 10.0625 3.7965 9.78363 3.874V5.02887C9.78363 5.40062 9.65221 5.71792 9.38937 5.98075C9.12654 6.24358 8.80925 6.375 8.4375 6.375L6.375 6.375L6.375 8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.21137 10.0979 6.95137 10.3588C6.69137 10.6196 6.37567 10.75 6.00425 10.75C5.63283 10.75 5.31571 10.6196 5.05287 10.3588C4.79004 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126L5.625 6.375H3.5625C3.19075 6.375 2.87346 6.24358 2.61062 5.98075C2.34779 5.71792 2.21637 5.40062 2.21637 5.02887V3.874C1.93754 3.7965 1.70675 3.639 1.524 3.4015C1.34133 3.164 1.25 2.89396 1.25 2.59137C1.25 2.21879 1.38142 1.90208 1.64425 1.64125C1.90708 1.38042 2.22421 1.25 2.59562 1.25C2.96704 1.25 3.28275 1.38042 3.54275 1.64125C3.80267 1.90208 3.93262 2.21879 3.93262 2.59137C3.93262 2.89396 3.84129 3.164 3.65863 3.4015C3.47596 3.639 3.24521 3.7965 2.96637 3.874V5.02887C2.96637 5.19779 3.0235 5.33938 3.13775 5.45363C3.252 5.56787 3.39358 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.79004 1.90208 5.05287 1.64125C5.31571 1.38042 5.63283 1.25 6.00425 1.25C6.37567 1.25 6.69137 1.38042 6.95137 1.64125C7.21137 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625L8.4375 5.625C8.60642 5.625 8.748 5.56787 8.86225 5.45363C8.9765 5.33938 9.03363 5.19779 9.03363 5.02887V3.874C8.75479 3.7965 8.52404 3.639 8.34137 3.4015C8.15871 3.164 8.06738 2.89396 8.06738 2.59137C8.06738 2.21879 8.19875 1.90208 8.4615 1.64125C8.72433 1.38042 9.04146 1.25 9.41287 1.25ZM9.411 2C9.24533 2 9.10496 2.05667 8.98987 2.17C8.87479 2.28325 8.81725 2.42362 8.81725 2.59112C8.81725 2.75862 8.87442 2.89908 8.98875 3.0125C9.103 3.126 9.24458 3.18275 9.4135 3.18275C9.57758 3.18275 9.71633 3.12521 9.82975 3.01012C9.94325 2.89504 10 2.75546 10 2.59137C10 2.42729 9.94325 2.28771 9.82975 2.17262C9.71633 2.05754 9.57675 2 9.411 2ZM6.00238 2C5.83671 2 5.69633 2.05667 5.58125 2.17C5.46617 2.28325 5.40863 2.42362 5.40863 2.59112C5.40863 2.75862 5.46575 2.89908 5.58 3.0125C5.69433 3.126 5.83592 3.18275 6.00475 3.18275C6.16892 3.18275 6.30771 3.12521 6.42112 3.01012C6.53463 2.89504 6.59137 2.75546 6.59137 2.59137C6.59137 2.42729 6.53463 2.28771 6.42112 2.17262C6.30771 2.05754 6.16813 2 6.00238 2ZM2.59375 2C2.42808 2 2.28771 2.05667 2.17262 2.17C2.05754 2.28325 2 2.42362 2 2.59112C2 2.75862 2.05713 2.89908 2.17138 3.0125C2.28563 3.126 2.42721 3.18275 2.59612 3.18275C2.76029 3.18275 2.89908 3.12521 3.0125 3.01012C3.126 2.89504 3.18275 2.75546 3.18275 2.59137C3.18275 2.42729 3.126 2.28771 3.0125 2.17262C2.89908 2.05754 2.7595 2 2.59375 2ZM6.00238 8.81725C5.83671 8.81725 5.69633 8.87392 5.58125 8.98725C5.46617 9.1005 5.40863 9.24087 5.40863 9.40837C5.40863 9.57587 5.46575 9.71633 5.58 9.82975C5.69433 9.94325 5.83592 10 6.00475 10C6.16892 10 6.30771 9.94246 6.42112 9.82737C6.53463 9.71229 6.59137 9.57271 6.59137 9.40863C6.59137 9.24454 6.53463 9.10496 6.42112 8.98987C6.30771 8.87479 6.16813 8.81725 6.00238 8.81725Z"
                                fill="#B7B7B9"
                              />
                            </svg>
                          ) : (selectedarr?.filter(
                            (item) =>
                              item?.type === node?.type && item?.name === node?.name
                          )?.length > 0 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M9.41287 1.25C9.78429 1.25 10.1 1.38042 10.36 1.64125C10.62 1.90208 10.75 2.21879 10.75 2.59137C10.75 2.89396 10.6587 3.164 10.476 3.4015C10.2933 3.639 10.0625 3.7965 9.78363 3.874V5.02887C9.78363 5.40062 9.65221 5.71792 9.38937 5.98075C9.12654 6.24358 8.80925 6.375 8.4375 6.375L6.375 6.375L6.375 8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.21137 10.0979 6.95137 10.3588C6.69137 10.6196 6.37567 10.75 6.00425 10.75C5.63283 10.75 5.31571 10.6196 5.05287 10.3588C4.79004 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126L5.625 6.375H3.5625C3.19075 6.375 2.87346 6.24358 2.61062 5.98075C2.34779 5.71792 2.21637 5.40062 2.21637 5.02887V3.874C1.93754 3.7965 1.70675 3.639 1.524 3.4015C1.34133 3.164 1.25 2.89396 1.25 2.59137C1.25 2.21879 1.38142 1.90208 1.64425 1.64125C1.90708 1.38042 2.22421 1.25 2.59562 1.25C2.96704 1.25 3.28275 1.38042 3.54275 1.64125C3.80267 1.90208 3.93262 2.21879 3.93262 2.59137C3.93262 2.89396 3.84129 3.164 3.65863 3.4015C3.47596 3.639 3.24521 3.7965 2.96637 3.874V5.02887C2.96637 5.19779 3.0235 5.33938 3.13775 5.45363C3.252 5.56787 3.39358 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.79004 1.90208 5.05287 1.64125C5.31571 1.38042 5.63283 1.25 6.00425 1.25C6.37567 1.25 6.69137 1.38042 6.95137 1.64125C7.21137 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625L8.4375 5.625C8.60642 5.625 8.748 5.56787 8.86225 5.45363C8.9765 5.33938 9.03363 5.19779 9.03363 5.02887V3.874C8.75479 3.7965 8.52404 3.639 8.34137 3.4015C8.15871 3.164 8.06738 2.89396 8.06738 2.59137C8.06738 2.21879 8.19875 1.90208 8.4615 1.64125C8.72433 1.38042 9.04146 1.25 9.41287 1.25ZM9.411 2C9.24533 2 9.10496 2.05667 8.98987 2.17C8.87479 2.28325 8.81725 2.42362 8.81725 2.59112C8.81725 2.75862 8.87442 2.89908 8.98875 3.0125C9.103 3.126 9.24458 3.18275 9.4135 3.18275C9.57758 3.18275 9.71633 3.12521 9.82975 3.01012C9.94325 2.89504 10 2.75546 10 2.59137C10 2.42729 9.94325 2.28771 9.82975 2.17262C9.71633 2.05754 9.57675 2 9.411 2ZM6.00238 2C5.83671 2 5.69633 2.05667 5.58125 2.17C5.46617 2.28325 5.40863 2.42362 5.40863 2.59112C5.40863 2.75862 5.46575 2.89908 5.58 3.0125C5.69433 3.126 5.83592 3.18275 6.00475 3.18275C6.16892 3.18275 6.30771 3.12521 6.42112 3.01012C6.53463 2.89504 6.59137 2.75546 6.59137 2.59137C6.59137 2.42729 6.53463 2.28771 6.42112 2.17262C6.30771 2.05754 6.16813 2 6.00238 2ZM2.59375 2C2.42808 2 2.28771 2.05667 2.17262 2.17C2.05754 2.28325 2 2.42362 2 2.59112C2 2.75862 2.05713 2.89908 2.17138 3.0125C2.28563 3.126 2.42721 3.18275 2.59612 3.18275C2.76029 3.18275 2.89908 3.12521 3.0125 3.01012C3.126 2.89504 3.18275 2.75546 3.18275 2.59137C3.18275 2.42729 3.126 2.28771 3.0125 2.17262C2.89908 2.05754 2.7595 2 2.59375 2ZM6.00238 8.81725C5.83671 8.81725 5.69633 8.87392 5.58125 8.98725C5.46617 9.1005 5.40863 9.24087 5.40863 9.40837C5.40863 9.57587 5.46575 9.71633 5.58 9.82975C5.69433 9.94325 5.83592 10 6.00475 10C6.16892 10 6.30771 9.94246 6.42112 9.82737C6.53463 9.71229 6.59137 9.57271 6.59137 9.40863C6.59137 9.24454 6.53463 9.10496 6.42112 8.98987C6.30771 8.87479 6.16813 8.81725 6.00238 8.81725Z"
                                fill="#B7B7B9"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M2.58713 10.75C2.21571 10.75 1.9 10.6196 1.64 10.3588C1.38 10.0979 1.25 9.78121 1.25 9.40863C1.25 9.10604 1.34133 8.836 1.524 8.5985C1.70675 8.361 1.93754 8.2035 2.21637 8.126V6.97113C2.21637 6.59938 2.34779 6.28208 2.61063 6.01925C2.87346 5.75642 3.19075 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.78863 1.90208 5.04863 1.64125C5.30863 1.38042 5.62433 1.25 5.99575 1.25C6.36717 1.25 6.68429 1.38042 6.94713 1.64125C7.20996 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625H8.4375C8.80925 5.625 9.12654 5.75642 9.38938 6.01925C9.65221 6.28208 9.78363 6.59938 9.78363 6.97113V8.126C10.0625 8.2035 10.2933 8.361 10.476 8.5985C10.6587 8.836 10.75 9.10604 10.75 9.40863C10.75 9.78121 10.6186 10.0979 10.3558 10.3588C10.0929 10.6196 9.77579 10.75 9.40438 10.75C9.03296 10.75 8.71725 10.6196 8.45725 10.3588C8.19733 10.0979 8.06738 9.78121 8.06738 9.40863C8.06738 9.10604 8.15871 8.836 8.34137 8.5985C8.52404 8.361 8.75479 8.2035 9.03363 8.126V6.97113C9.03363 6.80221 8.9765 6.66062 8.86225 6.54637C8.748 6.43213 8.60642 6.375 8.4375 6.375H6.375V8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.20996 10.0979 6.94713 10.3588C6.68429 10.6196 6.36717 10.75 5.99575 10.75C5.62433 10.75 5.30863 10.6196 5.04863 10.3588C4.78863 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126V6.375H3.5625C3.39358 6.375 3.252 6.43213 3.13775 6.54637C3.0235 6.66062 2.96637 6.80221 2.96637 6.97113V8.126C3.24521 8.2035 3.47596 8.361 3.65863 8.5985C3.84129 8.836 3.93262 9.10604 3.93262 9.40863C3.93262 9.78121 3.80125 10.0979 3.5385 10.3588C3.27567 10.6196 2.95854 10.75 2.58713 10.75ZM2.589 10C2.75467 10 2.89504 9.94333 3.01013 9.83C3.12521 9.71675 3.18275 9.57638 3.18275 9.40888C3.18275 9.24138 3.12558 9.10092 3.01125 8.9875C2.897 8.874 2.75542 8.81725 2.5865 8.81725C2.42242 8.81725 2.28367 8.87479 2.17025 8.98988C2.05675 9.10496 2 9.24454 2 9.40863C2 9.57271 2.05675 9.71229 2.17025 9.82738C2.28367 9.94246 2.42325 10 2.589 10ZM5.99762 10C6.16329 10 6.30367 9.94333 6.41875 9.83C6.53383 9.71675 6.59137 9.57638 6.59137 9.40888C6.59137 9.24138 6.53425 9.10092 6.42 8.9875C6.30567 8.874 6.16408 8.81725 5.99525 8.81725C5.83108 8.81725 5.69229 8.87479 5.57888 8.98988C5.46537 9.10496 5.40863 9.24454 5.40863 9.40863C5.40863 9.57271 5.46537 9.71229 5.57888 9.82738C5.69229 9.94246 5.83187 10 5.99762 10ZM9.40625 10C9.57192 10 9.71229 9.94333 9.82738 9.83C9.94246 9.71675 10 9.57638 10 9.40888C10 9.24138 9.94287 9.10092 9.82862 8.9875C9.71437 8.874 9.57279 8.81725 9.40388 8.81725C9.23971 8.81725 9.10092 8.87479 8.9875 8.98988C8.874 9.10496 8.81725 9.24454 8.81725 9.40863C8.81725 9.57271 8.874 9.71229 8.9875 9.82738C9.10092 9.94246 9.2405 10 9.40625 10ZM5.99762 3.18275C6.16329 3.18275 6.30367 3.12608 6.41875 3.01275C6.53383 2.8995 6.59137 2.75913 6.59137 2.59163C6.59137 2.42413 6.53425 2.28367 6.42 2.17025C6.30567 2.05675 6.16408 2 5.99525 2C5.83108 2 5.69229 2.05754 5.57888 2.17263C5.46537 2.28771 5.40863 2.42729 5.40863 2.59137C5.40863 2.75546 5.46537 2.89504 5.57888 3.01013C5.69229 3.12521 5.83187 3.18275 5.99762 3.18275Z"
                                fill="#97979A"
                              />
                            </svg>
                          )))}
                      </div>)}

                      {/* <div
                        className="flex p-1 items-center gap-1 rounded-[4px]"
                        style={{
                          backgroundColor: "#F2F2F5",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M5.75 7.4V4.6C5.75 4.48333 5.7 4.40417 5.6 4.3625C5.5 4.32083 5.40833 4.34167 5.325 4.425L4.1 5.65C4 5.75 3.95 5.86667 3.95 6C3.95 6.13333 4 6.25 4.1 6.35L5.325 7.575C5.40833 7.65833 5.5 7.67917 5.6 7.6375C5.7 7.59583 5.75 7.51667 5.75 7.4ZM2.5 10.5C2.225 10.5 1.98958 10.4021 1.79375 10.2063C1.59792 10.0104 1.5 9.775 1.5 9.5V2.5C1.5 2.225 1.59792 1.98958 1.79375 1.79375C1.98958 1.59792 2.225 1.5 2.5 1.5H9.5C9.775 1.5 10.0104 1.59792 10.2063 1.79375C10.4021 1.98958 10.5 2.225 10.5 2.5V9.5C10.5 9.775 10.4021 10.0104 10.2063 10.2063C10.0104 10.4021 9.775 10.5 9.5 10.5H2.5ZM8 9.5H9.5V2.5H8V9.5ZM7 9.5V2.5H2.5V9.5H7Z"
                            fill="#97979A"
                          />
                        </svg>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "sticky",
                    left: 300,
                    top: 0,
                    // background: "#E3EDF8",
                    backgroundColor: selectedarr[selectedarr?.length - 1]?.type === node?.type ? "#E3EDF8" : selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? "#FAFAFA" :
                      selectedarr?.filter(
                        (item) =>
                          item?.name === node?.name && item?.type === node?.type
                      )?.length > 0
                        ? "#FAFAFA"
                        : "#FFF",
                    zIndex: -100,
                    height: rowHeight
                  }}
                >
                  <div className="flex" style={{
                      borderRight: "1px solid #EAEAED",
                  }}>
                    {node?.row?.length > 0 &&
                      node.row.map((matrice: any) => {
                        return (
                          <div className="flex">
                            {columns?.map(({ field }) => {
                              return (
                                <div
                                  className="flex w-[120px] px-6 py-1 flex-col justify-center items-end gap-1"
                                  style={{
                                    // backgroundColor: "#FAFAFA",
                                    height: rowHeight,
                                    borderBottom: "1px solid #EAEAED",
                                    // borderRight: "1px solid #EAEAED",
                                  }}
                                  key={field}
                                >
                                  <div className="flex flex-col gap-1">
                                  {parameters_hierarchy?.map((parameter) => {
                                                              if(sel_parameters.includes(parameter)){
                                                              let color_val = "#1C1C1E"; // Default color for "current"
                                  
                                                              if (parameter === "previous") {
                                                                color_val = "#97979A";
                                                              } else if (
                                                                parameter === "difference" ||
                                                                parameter === "difference_percentage"
                                                              ) {
                                                                if (positive_values.includes(field)) {
                                                                  if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) >
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#186846";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) <
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#D10C00";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) ===
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#8B6509";
                                                                  }
                                                                } else if (negative_values.includes(field)) {
                                                                  if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) >
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#D10C00";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) <
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#186846";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) ===
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#8B6509";
                                                                  }
                                                                }
                                                              }
                                  
                                                              return (
                                                                <div
                                                                  key={parameter}
                                                                  style={{
                                                                    color: color_val,
                                                                    textAlign: "right",
                                                                    fontFamily: "Inter",
                                                                    fontSize:
                                                                      parameter === "current" ? "12px" : "10px",
                                                                    fontStyle: "normal",
                                                                    fontWeight:
                                                                      parameter === "current" ||
                                                                      parameter === "previous"
                                                                        ? "400"
                                                                        : "500",
                                                                    lineHeight:
                                                                      parameter === "current" ? "18px" : "14px",
                                                                  }}
                                                                >
                                                                  {parameter === "difference_percentage" ? `${matrice[field]?.[parameter]}%` : rsmatricearr?.includes(field) ? `₹ ${matrice[field]?.[parameter]}` : `${matrice[field]?.[parameter]}` }
                                  
                                                                  {/* {data[field]?.[parameter] &&
                                                                    formatNumber(
                                                                      Number(data[field]?.[parameter])
                                                                    )}
                                                                  {data[field]?.[parameter] &&
                                                                    parameter === "difference_percentage" &&
                                                                    " %"} */}
                                                                </div>
                                                              );
                                                            }
                                                            })}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if(selectedarr?.some(item => item?.type === node?.type && item?.name == node?.id)){
          rows.push(
            <div key={`${node?.type}-${node?.name}`} className="relative h-fit" >
              <div
                style={{
                  display: "flex",
                  width: "fit-content",
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 5,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "sticky",
                    left: 0,
                    top: 0,
                    // width: `${(selectedarr?.length * 24) + 250}px`,
                    // paddingLeft: level*24,
                    width: '300px',
                    paddingRight: "12px",
                    paddingLeft: "12px",
                    height: rowHeight,
                    backgroundColor: selectedarr[selectedarr?.length - 1]?.type === node?.type ? "#E3EDF8" : selPreviousArr?.some(item => item?.name === node?.id && item?.type === node?.type) ? "#FAFAFA" :
                    selectedarr?.filter(
                      (item) =>
                        item?.name === node?.id && item?.type === node?.type
                    )?.length > 0
                      ? "#FAFAFA"
                      : "#FFF",
                      borderBottom: "1px solid #EAEAED",
                      borderRight: "1px solid #EAEAED",
                    //   boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
                  }}
                >
                  <div
                    className="flex w-full py-1 flex-col justify-between items-start gap-1 self-stretch"
                    style={{
                      height: rowHeight
                    }}
                  >
                    <div
                      style={{
                        color: "var(--Text-Primary-Grey, #97979A)",
                        fontFamily: "Inter",
                        fontSize: "8px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "8px",
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {cols_hierarchy?.find(item => item?.backend_name === node?.type)?.frontend_name}
                    </div>
                    <div className="flex items-center gap-1">
                      <div
                        style={{
                          color: "var(--Text-Primary-Black, #1C1C1E)",
                          fontFamily: "Inter",
                          fontSize: "11px",
                          fontStyle: "normal",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          maxWidth: "246px",
                          fontWeight:
                            selectedarr?.filter(
                              (item) =>
                                item?.type === node?.type &&
                                item?.name == node?.id
                            )?.length > 0
                              ? 700
                              : 400,
                          lineHeight:
                            selectedarr?.filter(
                              (item) =>
                                item?.type === node?.type &&
                                item?.name == node?.id
                            )?.length > 0
                              ? "14px"
                              : "16px",
                        }}
                      >
                        {node?.name}
                      </div>
                    {cols_hierarchy[cols_hierarchy?.length - 1]?.backend_name !== node?.type && (
                      <div
                        className="flex p-1 items-center gap-1 rounded-[4px]"
                        style={{
                          backgroundColor:
                            node?.type !== "product_code" ? "#F3F3F7" : "#FFF",
                          cursor: selPreviousArr?.some(item => item?.name === node?.id && item?.type === node?.type) ? "default" : "pointer"
                        }}
                        onClick={() => {
                          if(selPreviousArr?.some(item => item?.name === node?.id && item?.type === node?.type)){
                            return;
                          }
                          else {
                            if (
                              selectedarr?.filter(
                                (item) =>
                                  item?.type === node?.type &&
                                  item?.name === node?.id
                              )?.length > 0
                            ) {
                              drillUp(node);
                            } else {
                              drilldown(node);
                            }
                          }
                        }}
                      >
                        {node.type !== "product_code" &&
                          (selPreviousArr?.some(item => item?.name === node?.id && item?.type === node?.type)  ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M9.41287 1.25C9.78429 1.25 10.1 1.38042 10.36 1.64125C10.62 1.90208 10.75 2.21879 10.75 2.59137C10.75 2.89396 10.6587 3.164 10.476 3.4015C10.2933 3.639 10.0625 3.7965 9.78363 3.874V5.02887C9.78363 5.40062 9.65221 5.71792 9.38937 5.98075C9.12654 6.24358 8.80925 6.375 8.4375 6.375L6.375 6.375L6.375 8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.21137 10.0979 6.95137 10.3588C6.69137 10.6196 6.37567 10.75 6.00425 10.75C5.63283 10.75 5.31571 10.6196 5.05287 10.3588C4.79004 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126L5.625 6.375H3.5625C3.19075 6.375 2.87346 6.24358 2.61062 5.98075C2.34779 5.71792 2.21637 5.40062 2.21637 5.02887V3.874C1.93754 3.7965 1.70675 3.639 1.524 3.4015C1.34133 3.164 1.25 2.89396 1.25 2.59137C1.25 2.21879 1.38142 1.90208 1.64425 1.64125C1.90708 1.38042 2.22421 1.25 2.59562 1.25C2.96704 1.25 3.28275 1.38042 3.54275 1.64125C3.80267 1.90208 3.93262 2.21879 3.93262 2.59137C3.93262 2.89396 3.84129 3.164 3.65863 3.4015C3.47596 3.639 3.24521 3.7965 2.96637 3.874V5.02887C2.96637 5.19779 3.0235 5.33938 3.13775 5.45363C3.252 5.56787 3.39358 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.79004 1.90208 5.05287 1.64125C5.31571 1.38042 5.63283 1.25 6.00425 1.25C6.37567 1.25 6.69137 1.38042 6.95137 1.64125C7.21137 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625L8.4375 5.625C8.60642 5.625 8.748 5.56787 8.86225 5.45363C8.9765 5.33938 9.03363 5.19779 9.03363 5.02887V3.874C8.75479 3.7965 8.52404 3.639 8.34137 3.4015C8.15871 3.164 8.06738 2.89396 8.06738 2.59137C8.06738 2.21879 8.19875 1.90208 8.4615 1.64125C8.72433 1.38042 9.04146 1.25 9.41287 1.25ZM9.411 2C9.24533 2 9.10496 2.05667 8.98987 2.17C8.87479 2.28325 8.81725 2.42362 8.81725 2.59112C8.81725 2.75862 8.87442 2.89908 8.98875 3.0125C9.103 3.126 9.24458 3.18275 9.4135 3.18275C9.57758 3.18275 9.71633 3.12521 9.82975 3.01012C9.94325 2.89504 10 2.75546 10 2.59137C10 2.42729 9.94325 2.28771 9.82975 2.17262C9.71633 2.05754 9.57675 2 9.411 2ZM6.00238 2C5.83671 2 5.69633 2.05667 5.58125 2.17C5.46617 2.28325 5.40863 2.42362 5.40863 2.59112C5.40863 2.75862 5.46575 2.89908 5.58 3.0125C5.69433 3.126 5.83592 3.18275 6.00475 3.18275C6.16892 3.18275 6.30771 3.12521 6.42112 3.01012C6.53463 2.89504 6.59137 2.75546 6.59137 2.59137C6.59137 2.42729 6.53463 2.28771 6.42112 2.17262C6.30771 2.05754 6.16813 2 6.00238 2ZM2.59375 2C2.42808 2 2.28771 2.05667 2.17262 2.17C2.05754 2.28325 2 2.42362 2 2.59112C2 2.75862 2.05713 2.89908 2.17138 3.0125C2.28563 3.126 2.42721 3.18275 2.59612 3.18275C2.76029 3.18275 2.89908 3.12521 3.0125 3.01012C3.126 2.89504 3.18275 2.75546 3.18275 2.59137C3.18275 2.42729 3.126 2.28771 3.0125 2.17262C2.89908 2.05754 2.7595 2 2.59375 2ZM6.00238 8.81725C5.83671 8.81725 5.69633 8.87392 5.58125 8.98725C5.46617 9.1005 5.40863 9.24087 5.40863 9.40837C5.40863 9.57587 5.46575 9.71633 5.58 9.82975C5.69433 9.94325 5.83592 10 6.00475 10C6.16892 10 6.30771 9.94246 6.42112 9.82737C6.53463 9.71229 6.59137 9.57271 6.59137 9.40863C6.59137 9.24454 6.53463 9.10496 6.42112 8.98987C6.30771 8.87479 6.16813 8.81725 6.00238 8.81725Z"
                                fill="#B7B7B9"
                              />
                            </svg>
                          ) : (selectedarr?.filter(
                            (item) =>
                              item?.type === node?.type && item?.name === node?.id
                          )?.length > 0 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M9.41287 1.25C9.78429 1.25 10.1 1.38042 10.36 1.64125C10.62 1.90208 10.75 2.21879 10.75 2.59137C10.75 2.89396 10.6587 3.164 10.476 3.4015C10.2933 3.639 10.0625 3.7965 9.78363 3.874V5.02887C9.78363 5.40062 9.65221 5.71792 9.38937 5.98075C9.12654 6.24358 8.80925 6.375 8.4375 6.375L6.375 6.375L6.375 8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.21137 10.0979 6.95137 10.3588C6.69137 10.6196 6.37567 10.75 6.00425 10.75C5.63283 10.75 5.31571 10.6196 5.05287 10.3588C4.79004 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126L5.625 6.375H3.5625C3.19075 6.375 2.87346 6.24358 2.61062 5.98075C2.34779 5.71792 2.21637 5.40062 2.21637 5.02887V3.874C1.93754 3.7965 1.70675 3.639 1.524 3.4015C1.34133 3.164 1.25 2.89396 1.25 2.59137C1.25 2.21879 1.38142 1.90208 1.64425 1.64125C1.90708 1.38042 2.22421 1.25 2.59562 1.25C2.96704 1.25 3.28275 1.38042 3.54275 1.64125C3.80267 1.90208 3.93262 2.21879 3.93262 2.59137C3.93262 2.89396 3.84129 3.164 3.65863 3.4015C3.47596 3.639 3.24521 3.7965 2.96637 3.874V5.02887C2.96637 5.19779 3.0235 5.33938 3.13775 5.45363C3.252 5.56787 3.39358 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.79004 1.90208 5.05287 1.64125C5.31571 1.38042 5.63283 1.25 6.00425 1.25C6.37567 1.25 6.69137 1.38042 6.95137 1.64125C7.21137 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625L8.4375 5.625C8.60642 5.625 8.748 5.56787 8.86225 5.45363C8.9765 5.33938 9.03363 5.19779 9.03363 5.02887V3.874C8.75479 3.7965 8.52404 3.639 8.34137 3.4015C8.15871 3.164 8.06738 2.89396 8.06738 2.59137C8.06738 2.21879 8.19875 1.90208 8.4615 1.64125C8.72433 1.38042 9.04146 1.25 9.41287 1.25ZM9.411 2C9.24533 2 9.10496 2.05667 8.98987 2.17C8.87479 2.28325 8.81725 2.42362 8.81725 2.59112C8.81725 2.75862 8.87442 2.89908 8.98875 3.0125C9.103 3.126 9.24458 3.18275 9.4135 3.18275C9.57758 3.18275 9.71633 3.12521 9.82975 3.01012C9.94325 2.89504 10 2.75546 10 2.59137C10 2.42729 9.94325 2.28771 9.82975 2.17262C9.71633 2.05754 9.57675 2 9.411 2ZM6.00238 2C5.83671 2 5.69633 2.05667 5.58125 2.17C5.46617 2.28325 5.40863 2.42362 5.40863 2.59112C5.40863 2.75862 5.46575 2.89908 5.58 3.0125C5.69433 3.126 5.83592 3.18275 6.00475 3.18275C6.16892 3.18275 6.30771 3.12521 6.42112 3.01012C6.53463 2.89504 6.59137 2.75546 6.59137 2.59137C6.59137 2.42729 6.53463 2.28771 6.42112 2.17262C6.30771 2.05754 6.16813 2 6.00238 2ZM2.59375 2C2.42808 2 2.28771 2.05667 2.17262 2.17C2.05754 2.28325 2 2.42362 2 2.59112C2 2.75862 2.05713 2.89908 2.17138 3.0125C2.28563 3.126 2.42721 3.18275 2.59612 3.18275C2.76029 3.18275 2.89908 3.12521 3.0125 3.01012C3.126 2.89504 3.18275 2.75546 3.18275 2.59137C3.18275 2.42729 3.126 2.28771 3.0125 2.17262C2.89908 2.05754 2.7595 2 2.59375 2ZM6.00238 8.81725C5.83671 8.81725 5.69633 8.87392 5.58125 8.98725C5.46617 9.1005 5.40863 9.24087 5.40863 9.40837C5.40863 9.57587 5.46575 9.71633 5.58 9.82975C5.69433 9.94325 5.83592 10 6.00475 10C6.16892 10 6.30771 9.94246 6.42112 9.82737C6.53463 9.71229 6.59137 9.57271 6.59137 9.40863C6.59137 9.24454 6.53463 9.10496 6.42112 8.98987C6.30771 8.87479 6.16813 8.81725 6.00238 8.81725Z"
                                fill="#B7B7B9"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M2.58713 10.75C2.21571 10.75 1.9 10.6196 1.64 10.3588C1.38 10.0979 1.25 9.78121 1.25 9.40863C1.25 9.10604 1.34133 8.836 1.524 8.5985C1.70675 8.361 1.93754 8.2035 2.21637 8.126V6.97113C2.21637 6.59938 2.34779 6.28208 2.61063 6.01925C2.87346 5.75642 3.19075 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.78863 1.90208 5.04863 1.64125C5.30863 1.38042 5.62433 1.25 5.99575 1.25C6.36717 1.25 6.68429 1.38042 6.94713 1.64125C7.20996 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625H8.4375C8.80925 5.625 9.12654 5.75642 9.38938 6.01925C9.65221 6.28208 9.78363 6.59938 9.78363 6.97113V8.126C10.0625 8.2035 10.2933 8.361 10.476 8.5985C10.6587 8.836 10.75 9.10604 10.75 9.40863C10.75 9.78121 10.6186 10.0979 10.3558 10.3588C10.0929 10.6196 9.77579 10.75 9.40438 10.75C9.03296 10.75 8.71725 10.6196 8.45725 10.3588C8.19733 10.0979 8.06738 9.78121 8.06738 9.40863C8.06738 9.10604 8.15871 8.836 8.34137 8.5985C8.52404 8.361 8.75479 8.2035 9.03363 8.126V6.97113C9.03363 6.80221 8.9765 6.66062 8.86225 6.54637C8.748 6.43213 8.60642 6.375 8.4375 6.375H6.375V8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.20996 10.0979 6.94713 10.3588C6.68429 10.6196 6.36717 10.75 5.99575 10.75C5.62433 10.75 5.30863 10.6196 5.04863 10.3588C4.78863 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126V6.375H3.5625C3.39358 6.375 3.252 6.43213 3.13775 6.54637C3.0235 6.66062 2.96637 6.80221 2.96637 6.97113V8.126C3.24521 8.2035 3.47596 8.361 3.65863 8.5985C3.84129 8.836 3.93262 9.10604 3.93262 9.40863C3.93262 9.78121 3.80125 10.0979 3.5385 10.3588C3.27567 10.6196 2.95854 10.75 2.58713 10.75ZM2.589 10C2.75467 10 2.89504 9.94333 3.01013 9.83C3.12521 9.71675 3.18275 9.57638 3.18275 9.40888C3.18275 9.24138 3.12558 9.10092 3.01125 8.9875C2.897 8.874 2.75542 8.81725 2.5865 8.81725C2.42242 8.81725 2.28367 8.87479 2.17025 8.98988C2.05675 9.10496 2 9.24454 2 9.40863C2 9.57271 2.05675 9.71229 2.17025 9.82738C2.28367 9.94246 2.42325 10 2.589 10ZM5.99762 10C6.16329 10 6.30367 9.94333 6.41875 9.83C6.53383 9.71675 6.59137 9.57638 6.59137 9.40888C6.59137 9.24138 6.53425 9.10092 6.42 8.9875C6.30567 8.874 6.16408 8.81725 5.99525 8.81725C5.83108 8.81725 5.69229 8.87479 5.57888 8.98988C5.46537 9.10496 5.40863 9.24454 5.40863 9.40863C5.40863 9.57271 5.46537 9.71229 5.57888 9.82738C5.69229 9.94246 5.83187 10 5.99762 10ZM9.40625 10C9.57192 10 9.71229 9.94333 9.82738 9.83C9.94246 9.71675 10 9.57638 10 9.40888C10 9.24138 9.94287 9.10092 9.82862 8.9875C9.71437 8.874 9.57279 8.81725 9.40388 8.81725C9.23971 8.81725 9.10092 8.87479 8.9875 8.98988C8.874 9.10496 8.81725 9.24454 8.81725 9.40863C8.81725 9.57271 8.874 9.71229 8.9875 9.82738C9.10092 9.94246 9.2405 10 9.40625 10ZM5.99762 3.18275C6.16329 3.18275 6.30367 3.12608 6.41875 3.01275C6.53383 2.8995 6.59137 2.75913 6.59137 2.59163C6.59137 2.42413 6.53425 2.28367 6.42 2.17025C6.30567 2.05675 6.16408 2 5.99525 2C5.83108 2 5.69229 2.05754 5.57888 2.17263C5.46537 2.28771 5.40863 2.42729 5.40863 2.59137C5.40863 2.75546 5.46537 2.89504 5.57888 3.01013C5.69229 3.12521 5.83187 3.18275 5.99762 3.18275Z"
                                fill="#97979A"
                              />
                            </svg>
                          )))}
                      </div>)}
                      
                      {/* <div
                        className="flex p-1 items-center gap-1 rounded-[4px]"
                        style={{
                          backgroundColor: "#F2F2F5",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M5.75 7.4V4.6C5.75 4.48333 5.7 4.40417 5.6 4.3625C5.5 4.32083 5.40833 4.34167 5.325 4.425L4.1 5.65C4 5.75 3.95 5.86667 3.95 6C3.95 6.13333 4 6.25 4.1 6.35L5.325 7.575C5.40833 7.65833 5.5 7.67917 5.6 7.6375C5.7 7.59583 5.75 7.51667 5.75 7.4ZM2.5 10.5C2.225 10.5 1.98958 10.4021 1.79375 10.2063C1.59792 10.0104 1.5 9.775 1.5 9.5V2.5C1.5 2.225 1.59792 1.98958 1.79375 1.79375C1.98958 1.59792 2.225 1.5 2.5 1.5H9.5C9.775 1.5 10.0104 1.59792 10.2063 1.79375C10.4021 1.98958 10.5 2.225 10.5 2.5V9.5C10.5 9.775 10.4021 10.0104 10.2063 10.2063C10.0104 10.4021 9.775 10.5 9.5 10.5H2.5ZM8 9.5H9.5V2.5H8V9.5ZM7 9.5V2.5H2.5V9.5H7Z"
                            fill="#97979A"
                          />
                        </svg>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "sticky",
                    left: 300,
                    top: 0,
                    // background: "#E3EDF8",
                    backgroundColor: selectedarr[selectedarr?.length - 1]?.type === node?.type ? "#E3EDF8" : selPreviousArr?.some(item => item?.name === node?.id && item?.type === node?.type) ? "#FAFAFA" :
                      selectedarr?.filter(
                        (item) =>
                          item?.name === node?.id && item?.type === node?.type
                      )?.length > 0
                        ? "#FAFAFA"
                        : "#FFF",
                    zIndex: -100,
                    height: rowHeight
                  }}
                >
                  <div className="flex" style={{
                      borderRight: "1px solid #EAEAED",
                  }}>
                    {node?.row?.length > 0 &&
                      node.row.map((matrice: any) => {
                        return (
                          <div className="flex">
                            {columns?.map(({ field }) => {
                              return (
                                <div
                                  className=" flex w-[120px] px-6 py-1 flex-col justify-center items-end gap-1"
                                  style={{
                                    // backgroundColor: "#FAFAFA",
                                    height: rowHeight,
                                    borderBottom: "1px solid #EAEAED",
                                    // borderRight: "1px solid #EAEAED",
                                  }}
                                  key={field}
                                >
                                  <div className="flex flex-col gap-1">
                                  {parameters_hierarchy?.map((parameter) => {
                                                              if(sel_parameters.includes(parameter)){
                                                              let color_val = "#1C1C1E"; // Default color for "current"
                                  
                                                              if (parameter === "previous") {
                                                                color_val = "#97979A";
                                                              } else if (
                                                                parameter === "difference" ||
                                                                parameter === "difference_percentage"
                                                              ) {
                                                                if (positive_values.includes(field)) {
                                                                  if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) >
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#186846";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) <
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#D10C00";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) ===
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#8B6509";
                                                                  }
                                                                } else if (negative_values.includes(field)) {
                                                                  if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) >
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#D10C00";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) <
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#186846";
                                                                  } else if (
                                                                    Number(removeCommas(matrice[field]?.["current"])) ===
                                                                    Number(removeCommas(matrice[field]?.["previous"]))
                                                                  ) {
                                                                    color_val = "#8B6509";
                                                                  }
                                                                }
                                                              }
                                  
                                                              return (
                                                                <div
                                                                  key={parameter}
                                                                  style={{
                                                                    color: color_val,
                                                                    textAlign: "right",
                                                                    fontFamily: "Inter",
                                                                    fontSize:
                                                                      parameter === "current" ? "12px" : "10px",
                                                                    fontStyle: "normal",
                                                                    fontWeight:
                                                                      parameter === "current" ||
                                                                      parameter === "previous"
                                                                        ? "400"
                                                                        : "500",
                                                                    lineHeight:
                                                                      parameter === "current" ? "18px" : "14px",
                                                                  }}
                                                                >
                                                                   {parameter === "difference_percentage" ? `${matrice[field]?.[parameter]}%` : rsmatricearr?.includes(field) ? `₹ ${matrice[field]?.[parameter]}` : `${matrice[field]?.[parameter]}` }
                                                                </div>
                                                              );
                                                            }
                                                            })}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }else if(selectedarr?.some(item => item?.type !== node?.type)){
          rows.push(
            <div key={`${index}-${node?.type}-${node?.name}`} className="relative h-fit" style={{
              display: searchobj?.value !== "" ? searchobj?.value === node?.name ? "block" : "none" : "block"
            }}>
              <div
                style={{
                  display: "flex",
                  width: "fit-content",
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 5,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "sticky",
                    left: 0,
                    top: 0,
                    // width: `${(selectedarr?.length * 24) + 250}px`,
                    // paddingLeft: level*24,
                    width: "300px",
                    paddingRight: "12px",
                    paddingLeft: "12px",
                    height: rowHeight,
                    backgroundColor: selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? "#FAFAFA" :
                    selectedarr?.filter(
                      (item) =>
                        item?.name === node?.name && item?.type === node?.type
                    )?.length > 0
                      ? "#FAFAFA"
                      : "#FFF",
                      borderBottom: "1px solid #EAEAED",
                      borderRight: "1px solid #EAEAED",
                    //   boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
                  }}
                >
                  <div
                    className="flex w-full py-1 flex-col justify-between items-start gap-1 self-stretch"
                    style={{
                      height: rowHeight
                    }}
                  >
                    <div
                      style={{
                        color: "var(--Text-Primary-Grey, #97979A)",
                        fontFamily: "Inter",
                        fontSize: "8px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "8px",
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {cols_hierarchy?.find(item => item?.backend_name === node?.type)?.frontend_name}
                    </div>
                    <div className="flex items-center gap-1">
                      <div
                        style={{
                          color: "var(--Text-Primary-Black, #1C1C1E)",
                          fontFamily: "Inter",
                          fontSize: "11px",
                          fontStyle: "normal",
                          wordWrap:"break-word",
                          overflowWrap: "break-word",
                          textWrap:"wrap",
                          maxWidth: "246px",
                          fontWeight:
                            selectedarr?.filter(
                              (item) =>
                                item?.type === node?.type &&
                                item?.name === node?.name
                            )?.length > 0
                              ? 700
                              : 400,
                          lineHeight:
                            selectedarr?.filter(
                              (item) =>
                                item?.type === node?.type &&
                                item?.name === node?.name
                            )?.length > 0
                              ? "14px"
                              : "16px",
                        }}
                      >
                        {node?.name}
                      </div>
                    {cols_hierarchy[cols_hierarchy?.length - 1]?.backend_name !== node?.type && (
                      <div
                        className="flex p-1 items-center gap-1 rounded-[4px]"
                        style={{
                          backgroundColor:
                            node?.type !== "product_code" ? "#F3F3F7" : "#FFF",
                          cursor: selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? "default" : "pointer"
                        }}
                        onClick={() => {
                          if(selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type)){
                            return;
                          }
                          else {
                            if (
                              selectedarr?.filter(
                                (item) =>
                                  item?.type === node?.type &&
                                  item?.name === node?.name
                              )?.length > 0
                            ) {
                              drillUp(node);
                            } else {
                              drilldown(node);
                            }
                          }
                        }}
                      >
                        {node.type !== "product_code" &&
                          (selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? (
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M9.41287 1.25C9.78429 1.25 10.1 1.38042 10.36 1.64125C10.62 1.90208 10.75 2.21879 10.75 2.59137C10.75 2.89396 10.6587 3.164 10.476 3.4015C10.2933 3.639 10.0625 3.7965 9.78363 3.874V5.02887C9.78363 5.40062 9.65221 5.71792 9.38937 5.98075C9.12654 6.24358 8.80925 6.375 8.4375 6.375L6.375 6.375L6.375 8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.21137 10.0979 6.95137 10.3588C6.69137 10.6196 6.37567 10.75 6.00425 10.75C5.63283 10.75 5.31571 10.6196 5.05287 10.3588C4.79004 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126L5.625 6.375H3.5625C3.19075 6.375 2.87346 6.24358 2.61062 5.98075C2.34779 5.71792 2.21637 5.40062 2.21637 5.02887V3.874C1.93754 3.7965 1.70675 3.639 1.524 3.4015C1.34133 3.164 1.25 2.89396 1.25 2.59137C1.25 2.21879 1.38142 1.90208 1.64425 1.64125C1.90708 1.38042 2.22421 1.25 2.59562 1.25C2.96704 1.25 3.28275 1.38042 3.54275 1.64125C3.80267 1.90208 3.93262 2.21879 3.93262 2.59137C3.93262 2.89396 3.84129 3.164 3.65863 3.4015C3.47596 3.639 3.24521 3.7965 2.96637 3.874V5.02887C2.96637 5.19779 3.0235 5.33938 3.13775 5.45363C3.252 5.56787 3.39358 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.79004 1.90208 5.05287 1.64125C5.31571 1.38042 5.63283 1.25 6.00425 1.25C6.37567 1.25 6.69137 1.38042 6.95137 1.64125C7.21137 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625L8.4375 5.625C8.60642 5.625 8.748 5.56787 8.86225 5.45363C8.9765 5.33938 9.03363 5.19779 9.03363 5.02887V3.874C8.75479 3.7965 8.52404 3.639 8.34137 3.4015C8.15871 3.164 8.06738 2.89396 8.06738 2.59137C8.06738 2.21879 8.19875 1.90208 8.4615 1.64125C8.72433 1.38042 9.04146 1.25 9.41287 1.25ZM9.411 2C9.24533 2 9.10496 2.05667 8.98987 2.17C8.87479 2.28325 8.81725 2.42362 8.81725 2.59112C8.81725 2.75862 8.87442 2.89908 8.98875 3.0125C9.103 3.126 9.24458 3.18275 9.4135 3.18275C9.57758 3.18275 9.71633 3.12521 9.82975 3.01012C9.94325 2.89504 10 2.75546 10 2.59137C10 2.42729 9.94325 2.28771 9.82975 2.17262C9.71633 2.05754 9.57675 2 9.411 2ZM6.00238 2C5.83671 2 5.69633 2.05667 5.58125 2.17C5.46617 2.28325 5.40863 2.42362 5.40863 2.59112C5.40863 2.75862 5.46575 2.89908 5.58 3.0125C5.69433 3.126 5.83592 3.18275 6.00475 3.18275C6.16892 3.18275 6.30771 3.12521 6.42112 3.01012C6.53463 2.89504 6.59137 2.75546 6.59137 2.59137C6.59137 2.42729 6.53463 2.28771 6.42112 2.17262C6.30771 2.05754 6.16813 2 6.00238 2ZM2.59375 2C2.42808 2 2.28771 2.05667 2.17262 2.17C2.05754 2.28325 2 2.42362 2 2.59112C2 2.75862 2.05713 2.89908 2.17138 3.0125C2.28563 3.126 2.42721 3.18275 2.59612 3.18275C2.76029 3.18275 2.89908 3.12521 3.0125 3.01012C3.126 2.89504 3.18275 2.75546 3.18275 2.59137C3.18275 2.42729 3.126 2.28771 3.0125 2.17262C2.89908 2.05754 2.7595 2 2.59375 2ZM6.00238 8.81725C5.83671 8.81725 5.69633 8.87392 5.58125 8.98725C5.46617 9.1005 5.40863 9.24087 5.40863 9.40837C5.40863 9.57587 5.46575 9.71633 5.58 9.82975C5.69433 9.94325 5.83592 10 6.00475 10C6.16892 10 6.30771 9.94246 6.42112 9.82737C6.53463 9.71229 6.59137 9.57271 6.59137 9.40863C6.59137 9.24454 6.53463 9.10496 6.42112 8.98987C6.30771 8.87479 6.16813 8.81725 6.00238 8.81725Z"
                              fill="#B7B7B9"
                            />
                          </svg>
                          ) : (selectedarr?.filter(
                            (item) =>
                              item?.type === node?.type && item?.name === node?.name
                          )?.length > 0 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M9.41287 1.25C9.78429 1.25 10.1 1.38042 10.36 1.64125C10.62 1.90208 10.75 2.21879 10.75 2.59137C10.75 2.89396 10.6587 3.164 10.476 3.4015C10.2933 3.639 10.0625 3.7965 9.78363 3.874V5.02887C9.78363 5.40062 9.65221 5.71792 9.38937 5.98075C9.12654 6.24358 8.80925 6.375 8.4375 6.375L6.375 6.375L6.375 8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.21137 10.0979 6.95137 10.3588C6.69137 10.6196 6.37567 10.75 6.00425 10.75C5.63283 10.75 5.31571 10.6196 5.05287 10.3588C4.79004 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126L5.625 6.375H3.5625C3.19075 6.375 2.87346 6.24358 2.61062 5.98075C2.34779 5.71792 2.21637 5.40062 2.21637 5.02887V3.874C1.93754 3.7965 1.70675 3.639 1.524 3.4015C1.34133 3.164 1.25 2.89396 1.25 2.59137C1.25 2.21879 1.38142 1.90208 1.64425 1.64125C1.90708 1.38042 2.22421 1.25 2.59562 1.25C2.96704 1.25 3.28275 1.38042 3.54275 1.64125C3.80267 1.90208 3.93262 2.21879 3.93262 2.59137C3.93262 2.89396 3.84129 3.164 3.65863 3.4015C3.47596 3.639 3.24521 3.7965 2.96637 3.874V5.02887C2.96637 5.19779 3.0235 5.33938 3.13775 5.45363C3.252 5.56787 3.39358 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.79004 1.90208 5.05287 1.64125C5.31571 1.38042 5.63283 1.25 6.00425 1.25C6.37567 1.25 6.69137 1.38042 6.95137 1.64125C7.21137 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625L8.4375 5.625C8.60642 5.625 8.748 5.56787 8.86225 5.45363C8.9765 5.33938 9.03363 5.19779 9.03363 5.02887V3.874C8.75479 3.7965 8.52404 3.639 8.34137 3.4015C8.15871 3.164 8.06738 2.89396 8.06738 2.59137C8.06738 2.21879 8.19875 1.90208 8.4615 1.64125C8.72433 1.38042 9.04146 1.25 9.41287 1.25ZM9.411 2C9.24533 2 9.10496 2.05667 8.98987 2.17C8.87479 2.28325 8.81725 2.42362 8.81725 2.59112C8.81725 2.75862 8.87442 2.89908 8.98875 3.0125C9.103 3.126 9.24458 3.18275 9.4135 3.18275C9.57758 3.18275 9.71633 3.12521 9.82975 3.01012C9.94325 2.89504 10 2.75546 10 2.59137C10 2.42729 9.94325 2.28771 9.82975 2.17262C9.71633 2.05754 9.57675 2 9.411 2ZM6.00238 2C5.83671 2 5.69633 2.05667 5.58125 2.17C5.46617 2.28325 5.40863 2.42362 5.40863 2.59112C5.40863 2.75862 5.46575 2.89908 5.58 3.0125C5.69433 3.126 5.83592 3.18275 6.00475 3.18275C6.16892 3.18275 6.30771 3.12521 6.42112 3.01012C6.53463 2.89504 6.59137 2.75546 6.59137 2.59137C6.59137 2.42729 6.53463 2.28771 6.42112 2.17262C6.30771 2.05754 6.16813 2 6.00238 2ZM2.59375 2C2.42808 2 2.28771 2.05667 2.17262 2.17C2.05754 2.28325 2 2.42362 2 2.59112C2 2.75862 2.05713 2.89908 2.17138 3.0125C2.28563 3.126 2.42721 3.18275 2.59612 3.18275C2.76029 3.18275 2.89908 3.12521 3.0125 3.01012C3.126 2.89504 3.18275 2.75546 3.18275 2.59137C3.18275 2.42729 3.126 2.28771 3.0125 2.17262C2.89908 2.05754 2.7595 2 2.59375 2ZM6.00238 8.81725C5.83671 8.81725 5.69633 8.87392 5.58125 8.98725C5.46617 9.1005 5.40863 9.24087 5.40863 9.40837C5.40863 9.57587 5.46575 9.71633 5.58 9.82975C5.69433 9.94325 5.83592 10 6.00475 10C6.16892 10 6.30771 9.94246 6.42112 9.82737C6.53463 9.71229 6.59137 9.57271 6.59137 9.40863C6.59137 9.24454 6.53463 9.10496 6.42112 8.98987C6.30771 8.87479 6.16813 8.81725 6.00238 8.81725Z"
                                fill="#B7B7B9"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M2.58713 10.75C2.21571 10.75 1.9 10.6196 1.64 10.3588C1.38 10.0979 1.25 9.78121 1.25 9.40863C1.25 9.10604 1.34133 8.836 1.524 8.5985C1.70675 8.361 1.93754 8.2035 2.21637 8.126V6.97113C2.21637 6.59938 2.34779 6.28208 2.61063 6.01925C2.87346 5.75642 3.19075 5.625 3.5625 5.625H5.625V3.874C5.34617 3.7965 5.11542 3.639 4.93275 3.4015C4.75 3.164 4.65863 2.89396 4.65863 2.59137C4.65863 2.21879 4.78863 1.90208 5.04863 1.64125C5.30863 1.38042 5.62433 1.25 5.99575 1.25C6.36717 1.25 6.68429 1.38042 6.94713 1.64125C7.20996 1.90208 7.34137 2.21879 7.34137 2.59137C7.34137 2.89396 7.25 3.164 7.06725 3.4015C6.88458 3.639 6.65383 3.7965 6.375 3.874V5.625H8.4375C8.80925 5.625 9.12654 5.75642 9.38938 6.01925C9.65221 6.28208 9.78363 6.59938 9.78363 6.97113V8.126C10.0625 8.2035 10.2933 8.361 10.476 8.5985C10.6587 8.836 10.75 9.10604 10.75 9.40863C10.75 9.78121 10.6186 10.0979 10.3558 10.3588C10.0929 10.6196 9.77579 10.75 9.40438 10.75C9.03296 10.75 8.71725 10.6196 8.45725 10.3588C8.19733 10.0979 8.06738 9.78121 8.06738 9.40863C8.06738 9.10604 8.15871 8.836 8.34137 8.5985C8.52404 8.361 8.75479 8.2035 9.03363 8.126V6.97113C9.03363 6.80221 8.9765 6.66062 8.86225 6.54637C8.748 6.43213 8.60642 6.375 8.4375 6.375H6.375V8.126C6.65383 8.2035 6.88458 8.361 7.06725 8.5985C7.25 8.836 7.34137 9.10604 7.34137 9.40863C7.34137 9.78121 7.20996 10.0979 6.94713 10.3588C6.68429 10.6196 6.36717 10.75 5.99575 10.75C5.62433 10.75 5.30863 10.6196 5.04863 10.3588C4.78863 10.0979 4.65863 9.78121 4.65863 9.40863C4.65863 9.10604 4.75 8.836 4.93275 8.5985C5.11542 8.361 5.34617 8.2035 5.625 8.126V6.375H3.5625C3.39358 6.375 3.252 6.43213 3.13775 6.54637C3.0235 6.66062 2.96637 6.80221 2.96637 6.97113V8.126C3.24521 8.2035 3.47596 8.361 3.65863 8.5985C3.84129 8.836 3.93262 9.10604 3.93262 9.40863C3.93262 9.78121 3.80125 10.0979 3.5385 10.3588C3.27567 10.6196 2.95854 10.75 2.58713 10.75ZM2.589 10C2.75467 10 2.89504 9.94333 3.01013 9.83C3.12521 9.71675 3.18275 9.57638 3.18275 9.40888C3.18275 9.24138 3.12558 9.10092 3.01125 8.9875C2.897 8.874 2.75542 8.81725 2.5865 8.81725C2.42242 8.81725 2.28367 8.87479 2.17025 8.98988C2.05675 9.10496 2 9.24454 2 9.40863C2 9.57271 2.05675 9.71229 2.17025 9.82738C2.28367 9.94246 2.42325 10 2.589 10ZM5.99762 10C6.16329 10 6.30367 9.94333 6.41875 9.83C6.53383 9.71675 6.59137 9.57638 6.59137 9.40888C6.59137 9.24138 6.53425 9.10092 6.42 8.9875C6.30567 8.874 6.16408 8.81725 5.99525 8.81725C5.83108 8.81725 5.69229 8.87479 5.57888 8.98988C5.46537 9.10496 5.40863 9.24454 5.40863 9.40863C5.40863 9.57271 5.46537 9.71229 5.57888 9.82738C5.69229 9.94246 5.83187 10 5.99762 10ZM9.40625 10C9.57192 10 9.71229 9.94333 9.82738 9.83C9.94246 9.71675 10 9.57638 10 9.40888C10 9.24138 9.94287 9.10092 9.82862 8.9875C9.71437 8.874 9.57279 8.81725 9.40388 8.81725C9.23971 8.81725 9.10092 8.87479 8.9875 8.98988C8.874 9.10496 8.81725 9.24454 8.81725 9.40863C8.81725 9.57271 8.874 9.71229 8.9875 9.82738C9.10092 9.94246 9.2405 10 9.40625 10ZM5.99762 3.18275C6.16329 3.18275 6.30367 3.12608 6.41875 3.01275C6.53383 2.8995 6.59137 2.75913 6.59137 2.59163C6.59137 2.42413 6.53425 2.28367 6.42 2.17025C6.30567 2.05675 6.16408 2 5.99525 2C5.83108 2 5.69229 2.05754 5.57888 2.17263C5.46537 2.28771 5.40863 2.42729 5.40863 2.59137C5.40863 2.75546 5.46537 2.89504 5.57888 3.01013C5.69229 3.12521 5.83187 3.18275 5.99762 3.18275Z"
                                fill="#97979A"
                              />
                            </svg>
                          )))}
                      </div>)}
                    
                    </div>
                  </div>
                </div>
  
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "sticky",
                    left: 300,
                    top: 0,
                    // background: "#E3EDF8",
                    backgroundColor: selPreviousArr?.some(item => item?.name === node?.name && item?.type === node?.type) ? "#FAFAFA" :
                      selectedarr?.filter(
                        (item) =>
                          item?.name === node?.name && item?.type === node?.type
                      )?.length > 0
                        ? "#FAFAFA"
                        : "#FFF",
                    zIndex: -100,
                    height: rowHeight
                  }}
                >
                  <div className="flex" style={{
                      borderRight: "1px solid #EAEAED",
                  }}>
                    {node?.row?.length > 0 &&
                      node.row.map((matrice: any) => {
                        return (
                          <div className="flex">
                            {columns?.map(({ field }) => {
                              return (
                                <div
                                  className="flex w-[120px] px-6 py-1 flex-col justify-center items-end gap-1"
                                  style={{
                                    height: rowHeight,
                                    // backgroundColor: "#FAFAFA",
                                    borderBottom: "1px solid #EAEAED",
                                    // borderRight: "1px solid #EAEAED",
                                  }}
                                  key={field}
                                >
                                  <div className="flex flex-col gap-1">
                                    {parameters_hierarchy?.map((parameter) => {
                                                                if(sel_parameters.includes(parameter)){
                                                                let color_val = "#1C1C1E"; // Default color for "current"
                                    
                                                                if (parameter === "previous") {
                                                                  color_val = "#97979A";
                                                                } else if (
                                                                  parameter === "difference" ||
                                                                  parameter === "difference_percentage"
                                                                ) {
                                                                  if (positive_values.includes(field)) {
                                                                    if (
                                                                      Number(removeCommas(matrice[field]?.["current"])) >
                                                                      Number(removeCommas(matrice[field]?.["previous"]))
                                                                    ) {
                                                                      color_val = "#186846";
                                                                    } else if (
                                                                      Number(removeCommas(matrice[field]?.["current"])) <
                                                                      Number(removeCommas(matrice[field]?.["previous"]))
                                                                    ) {
                                                                      color_val = "#D10C00";
                                                                    } else if (
                                                                      Number(removeCommas(matrice[field]?.["current"])) ===
                                                                      Number(removeCommas(matrice[field]?.["previous"]))
                                                                    ) {
                                                                      color_val = "#8B6509";
                                                                    }
                                                                  } else if (negative_values.includes(field)) {
                                                                    if (
                                                                      Number(removeCommas(matrice[field]?.["current"])) >
                                                                      Number(removeCommas(matrice[field]?.["previous"]))
                                                                    ) {
                                                                      color_val = "#D10C00";
                                                                    } else if (
                                                                      Number(removeCommas(matrice[field]?.["current"])) <
                                                                      Number(removeCommas(matrice[field]?.["previous"]))
                                                                    ) {
                                                                      color_val = "#186846";
                                                                    } else if (
                                                                      Number(removeCommas(matrice[field]?.["current"])) ===
                                                                      Number(removeCommas(matrice[field]?.["previous"]))
                                                                    ) {
                                                                      color_val = "#8B6509";
                                                                    }
                                                                  }
                                                                }
                                    
                                                                return (
                                                                  <div
                                                                    key={parameter}
                                                                    style={{
                                                                      color: color_val,
                                                                      textAlign: "right",
                                                                      fontFamily: "Inter",
                                                                      fontSize:
                                                                        parameter === "current" ? "12px" : "10px",
                                                                      fontStyle: "normal",
                                                                      fontWeight:
                                                                        parameter === "current" ||
                                                                        parameter === "previous"
                                                                          ? "400"
                                                                          : "500",
                                                                      lineHeight:
                                                                        parameter === "current" ? "18px" : "14px",
                                                                    }}
                                                                  >
                                                                    {parameter === "difference_percentage" ? `${matrice[field]?.[parameter]}%` : rsmatricearr?.includes(field) ? `₹ ${matrice[field]?.[parameter]}` : `${matrice[field]?.[parameter]}` }
                                                                  </div>
                                                                );
                                                              }
                                                              })}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          );
        }

      // If the current node has children, recursively traverse each child
        if (
        selectedarr?.filter(
          (item2) => item2?.type === node?.type && (item2?.name == node?.name || item2?.name === node?.id)
        )?.length > 0 &&
        node?.children?.length > 0
      ) {
          node?.children?.forEach((child: any) => traverseData(child, level + 1));
      } 
    }

    traverseData(data, 1);
    
    return <div>{rows}</div>;
  };

  const onSortChangeHandler = (el : RowProps) => {
    setSort((prev) => {
      let new_sort_obj = {} as SortProps;
      if (prev.metric !== el.field) {
          new_sort_obj = {
            ...prev,
            metric: el.field,
            direction: "ASC",
            };
          fetchonClick(data[data?.length - 1], sel_categories, selectedarr, new_sort_obj);
          return new_sort_obj;
      } else if (prev.metric === el.field) {
          if (prev.direction === "ASC") {
            new_sort_obj = {
              ...prev,
              direction: "DESC",
            };
            fetchonClick(data[data?.length - 1], sel_categories, selectedarr, new_sort_obj);
            return new_sort_obj;
          } else if (prev.direction === "DESC") {
            new_sort_obj = {
                ...prev,
                direction: "",
            };
            fetchonClick(data[data?.length - 1], sel_categories, selectedarr, new_sort_obj);
            return new_sort_obj;
          } else if (prev.direction === "") {
            new_sort_obj = {
                ...prev,
                direction: "ASC",
            };
            fetchonClick(data[data?.length - 1], sel_categories, selectedarr, new_sort_obj);
            return new_sort_obj;
          }
      }

      fetchonClick(data[data?.length - 1], sel_categories, selectedarr, new_sort_obj);
      return prev;
    })
  }

  return (
    <div
      style={{
        maxHeight: "calc(100vh - 160px)",
        width: "calc(100vw - 46px)"
      }}
    >
      <div ref={productDetailRowRef} style={{
        maxHeight: "calc(100vh - 160px)",
        width: "calc(100vw - 46px)",
        overflowX: "auto",
        position: "relative",
        zIndex: 5
      }}>

        <div
          style={{
            display: "flex",
            width: "fit-content",
            position: "sticky",
            top: 0,
            left: 0,
            background: "white",
            zIndex: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              position: "sticky",
              left: 0,
              top: 0,
              background: "white",
              boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
              zIndex: 10
            }}
          >
            <div
              className="flex h-full px-6 py-1 justify-center items-center gap-2 self-stretch"
              style={{
                textAlign: "center",
                background: "#F3F3F7",
                borderBottom: "1px solid #EAEAED",
                // width:`${selectedarr?.length * 24 + 250}px`
                width: "300px",
                paddingRight: "12px",
                paddingLeft: "12px",
              }}
            >
              <div
                style={{
                  color: "var(--Text-Primary-Black, #1C1C1E)",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "16px",
                }}
              >
                Journey Details
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              position: "sticky",
              // left: `${selectedarr?.length * 24 + 250}px`,
              left: 300,
              top: 0,
              zIndex: -100,
              borderRight: "1px solid #EAEAED",
            }}
          >
            <div
              className="cell h-[40px] gap-2 self-stretch"
              style={{
                textAlign: "center",
                background: "#F3F3F7",
                borderBottom: "1px solid #EAEAED",
                position: "relative",
                borderRight: "0px"
                // border: "1px solid black"
              }}
            >
              <div className="px-6 py-1 flex justify-center items-center" style={{
                position: 'sticky',
                top: 0,
                // left: `${selectedarr?.length * 24 + 250}px`,
                // maxWidth: `calc(100vw - ${selectedarr?.length * 24 + 250}px - 40px)`,
                left: 300,
                maxWidth: `calc(100vw - 300px - 40px)`,
                height: "100%"
              }}>
                <div
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "16px",
                  }}
                >
                  Matrices
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              {columns?.map((el: RowProps) => {
                return (
                  <div
                    className="cell flex w-[120px] h-[40px] px-6 py-1 justify-end items-center gap-2 cursor-pointer"
                    style={{
                      backgroundColor: "#F3F3F7",
                      borderRight: "0px",
                    }}
                   onClick={() => onSortChangeHandler(el)}
                  >
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        textAlign: "end",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "16px",
                      }}
                    >
                      {el.headerName}
                    </div>
                    {sort.metric === el.field && sort.direction === "ASC" && (
                        <img
                        src={UpArrowIcon}
                        alt="Icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() => setDateToggle(true)}
                        />
                    )}
                    {sort.metric === el.field && sort.direction === "DESC" && (
                        <img
                        src={DownArrowIcon}
                        alt="Icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() => setDateToggle(true)}
                        />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div
          style={{
            maxHeight: "calc(100vh - 160px - 87px)",
            zIndex: -100,
          }}
        >
          {data?.map((dataObj, index) => (
            <div key={index}>
              {RenderRows(dataObj)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DrillThroughTable;